import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Envelope, ArrowLeft } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devUrl, setDevUrl] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      if (data.dev_reset_url) setDevUrl(data.dev_reset_url);
    } catch (err) {
      toast.error("Something went wrong — please try again.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center bg-paper">
      <div className="max-w-md mx-auto w-full px-6 py-16">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm font-bold text-rf-orange hover:underline mb-6"><ArrowLeft size={14} /> Back to sign in</Link>
        <p className="overline mb-3">Forgot password</p>
        <h1 className="font-display text-4xl md:text-5xl font-black text-rf-ink mb-3 leading-tight">Reset, no fuss.</h1>
        <p className="text-rf-ink-soft mb-8">Enter the email you registered with and we'll send a reset link.</p>

        {sent ? (
          <div className="card-recipe text-center">
            <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-rf-amber/20 flex items-center justify-center">
              <Envelope size={28} weight="duotone" className="text-rf-orange" />
            </div>
            <h2 className="font-display text-2xl font-black text-rf-ink mb-2">Check your inbox</h2>
            <p className="text-rf-ink-soft text-sm">If <span className="font-bold">{email}</span> exists in our system, a reset link will arrive within a minute. The link expires in 60 minutes.</p>
            {devUrl && (
              <div className="mt-5 p-3 rounded-xl bg-rf-cream-alt text-left">
                <p className="text-xs font-bold text-rf-orange uppercase tracking-wider mb-1">Dev mode link</p>
                <a href={devUrl} className="text-xs font-mono break-all text-rf-ink-soft hover:text-rf-orange">{devUrl}</a>
              </div>
            )}
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="overline">Email</label>
              <input data-testid="forgot-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-rf mt-1" />
            </div>
            <button data-testid="forgot-submit" disabled={busy} className="btn-amber w-full">{busy ? "Sending…" : "Send reset link"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
